import {
    ANNOUNCEMENTS_IS_LOADING,
    ANNOUNCEMENTS_LOAD_ERROR,
    ANNOUNCEMENTS_LOAD_SUCCESS,
    ANSWER_QUESTION_ERROR,
    ANSWER_QUESTION_SUCCESS,
    COURSES_IS_LOADING,
    COURSES_LOAD_ERROR,
    COURSES_LOAD_SUCCESS,
    IS_ANSWERING_QUESTION,
    LEADERSHIP_BOARD_IS_LOADING,
    LEADERSHIP_BOARD_LOAD_ERROR,
    LEADERSHIP_BOARD_LOAD_SUCCESS,
    QUESTIONS_ARE_LOADING,
    QUESTIONS_LOAD_ERROR,
    QUESTIONS_LOAD_SUCCESS,
    QUIZZES_IS_LOADING,
    QUIZZES_LOAD_ERROR,
    QUIZZES_LOAD_SUCCESS,
    QUIZ_COMPLETED,
    QUIZ_IN_PROGRESS,
    QUIZ_LIST_IS_LOADING,
    QUIZ_LIST_LOAD_ERROR,
    QUIZ_LIST_LOAD_SUCCESS,
    REPORTS_IS_LOADING,
    REPORTS_LOAD_ERROR,
    REPORTS_LOAD_SUCCESS,
    RESET_ANSWER_STATE,
    RESET_QUESTIONS,
    RESET_QUIZ_STATE,
    RESET_SELECTED_COURSE,
    RESET_SELECTED_QUIZ,
    SELECTED_COURSE_IS_LOADING,
    SELECTED_COURSE_LOAD_ERROR,
    SELECTED_COURSE_LOAD_SUCCESS,
    SELECTED_MENU_ITEM,
    SELECTED_QUIZ_IS_LOADING,
    SELECTED_QUIZ_LOAD_ERROR,
    SELECTED_QUIZ_LOAD_SUCCESS,
    SET_HEADER_TEXT,
    STATISTICS_IS_LOADING,
    STATISTICS_LOAD_ERROR,
    STATISTICS_LOAD_SUCCESS,
    SET_TOPIC_AND_QUIZ,
    RESET_TOPIC_AND_QUIZ,
    MY_ACTIVITY_IS_LOADING,
    MY_ACTIVITY_LOAD_SUCCESS,
    MY_ACTIVITY_LOAD_ERROR,
    LIVE_COURSES_IS_LOADING,
    LIVE_COURSES_LOAD_SUCCESS,
    LIVE_COURSES_LOAD_ERROR,
    RESET_QUIZ_LIST,
    TOPIC_IS_STARTING,
    TOPIC_STARTED_SUCCESSFULLY,
    TOPIC_START_ERROR,
    TOPIC_START_RESET,
    MY_ACTIVITY_RESET,
    COMMENTS_IS_LOADING,
    COMMENTS_LOAD_SUCCESS,
    COMMENTS_LOAD_ERROR,
    COMMENTS_RESET,
    PLAY_AGAIN_QUIZ,
    SEARCH_AUTOCOMPLETE_LIST_LOADING,
    SEARCH_QUERY_LOADING,
    SEARCH_FINAL_QUERY,
    SEARCH_COMPONENT_RESET,
    SET_AUTOCOMPLETE_VISIBILITY,
    SET_ADVANCED_SEARCH,
    RESET_ADVANCED_SEARCH,
    SET_HEADER_ADVANCED_SEARCH_PARAMS,
    RESET_HEADER,
    CHANGE_FAVOURITE_VALUE,
    START_SETTING_FAVOURITE,
    END_SETTING_FAVOURITE,
} from "./action_types";
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']


export const coursesIsLoading = () => ({
    type: COURSES_IS_LOADING,
});

export const courseLoadingSuccess = (coursesData) => ({
    type: COURSES_LOAD_SUCCESS,
    payload: coursesData,
});

export const courseLoadingError = (errorMessage) => ({
    type: COURSES_LOAD_ERROR,
    payload: errorMessage,
});

export const selectedCourseIsLoading = () => ({
    type: SELECTED_COURSE_IS_LOADING
})

export const selectedCourseSuccess = (course) => ({
    type: SELECTED_COURSE_LOAD_SUCCESS,
    payload: course
})

export const selectedCourseError = (errorMessage) => ({
    type: SELECTED_COURSE_LOAD_ERROR,
    payload: errorMessage
})

export const resetSelectedCourse = () => ({
    type: RESET_SELECTED_COURSE
})

export const quizzesIsLoading = () => ({
    type: QUIZZES_IS_LOADING,
});

export const quizLoadingSuccess = (coursesData) => ({
    type: QUIZZES_LOAD_SUCCESS,
    payload: coursesData,
});

export const quizLoadingError = (errorMessage) => ({
    type: QUIZZES_LOAD_ERROR,
    payload: errorMessage,
});

export const selectedQuizIsLoading = () => ({
    type: SELECTED_QUIZ_IS_LOADING
})

export const selectedQuizSuccess = (quiz) => ({
    type: SELECTED_QUIZ_LOAD_SUCCESS,
    payload: quiz
})

export const selectedQuizError = (errorMessage) => ({
    type: SELECTED_QUIZ_LOAD_ERROR,
    payload: errorMessage
})

export const resetSelectedQuiz = () => ({
    type: RESET_SELECTED_QUIZ
})

export const questionsAreLoading = () => ({
    type: QUESTIONS_ARE_LOADING
})

export const questionsLoadSuccess = (questions) => ({
    type: QUESTIONS_LOAD_SUCCESS,
    payload: questions
})

export const questionsLoadError = (errorMessage) => ({
    type: QUESTIONS_LOAD_ERROR,
    payload: errorMessage
})

export const resetQuestions = () => ({
    type: RESET_QUESTIONS
})

export const setHeaderText = (headerText) => ({
    type: SET_HEADER_TEXT,
    payload: headerText
})

export const setHeaderAdvancedSearchParams = (params) => ({
    type: SET_HEADER_ADVANCED_SEARCH_PARAMS,
    payload: params
})

export const resetHeader = () => ({
    type: RESET_HEADER
})

export const setSelectedMenuItem = (id) => ({
    type: SELECTED_MENU_ITEM,
    payload: id
})

export const quizStarted = () => ({
    type: QUIZ_IN_PROGRESS
})

export const quizSubmitted = () => ({
    type: QUIZ_COMPLETED
})

export const resetQuizState = () => ({
    type: RESET_QUIZ_STATE
})

export const quizPlayAgain = () => ({
    type: PLAY_AGAIN_QUIZ
})

export const isAnswering = () => ({
    type: IS_ANSWERING_QUESTION
})

export const answerSubmitSuccess = () => ({
    type: ANSWER_QUESTION_SUCCESS
})

export const answerSubmitError = (errorMessage) => ({
    type: ANSWER_QUESTION_ERROR,
    payload: errorMessage
})

export const resetAnswerState = () => ({
    type: RESET_ANSWER_STATE
})

export const calculateDateRange = (start, end) => {
    const startDate = start.split("-");
    const endDate = end.split("-");
    if (startDate[0] === endDate[0]) {
        if (startDate[1] === endDate[1]) {
            return `${months[startDate[1] - 1]} ${startDate[2]} - ${endDate[2]}, ${startDate[0]
                }`;
        } else {
            return `${months[startDate[1] - 1]} ${startDate[2]} - ${months[endDate[1] - 1]
                } ${endDate[2]}, ${startDate[0]}`;
        }
    } else {
        return `${months[startDate[1] - 1]} ${startDate[2]}, ${startDate[0]} - ${months[endDate[1] - 1]
            } ${endDate[2]}, ${endDate[0]}`;
    }
};

export const calculateTimeTakenForQuestion = (time) => {
    time = time / 1000
    let seconds = Math.floor(time % 60)
    let minutes = Math.floor(time / 60)
    return (minutes < 10 ? '0' + minutes : minutes.toString()) + ":" + (seconds < 10 ? '0' + seconds : seconds.toString())
}

export const convertToMinutes = (timeString) => {
    const timeArray = timeString.split(':')
    const minutes = Number(timeArray[0])
    return minutes
}

export const formatDate = (date) => {
    const createdDate = date.split(" ")[0].split('-');
    const createdTime = date.split(" ")[1].split(':')
    const amPM = Number(createdTime[0] >= 12) ? 'PM' : 'AM'
    const hour = Number(createdTime[0]) > 12 ? Number(createdTime[0]) - 12 : Number(createdTime[0])
    return `${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]} at ${hour}:${createdTime[1]} ${amPM}`;
};

export const formatDateAnnouncements = (date) => {
    const createdDate = date.split("-");
    return `${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};

export const formatLiveCourseDateTime = (startTime) => {
    let startDateAndTime = new Date(Date.parse(startTime))
    let year = startDateAndTime.getFullYear()
    let month = (Number(startDateAndTime.getMonth()))
    let day = startDateAndTime.getDate()
    let hour = startDateAndTime.getHours()
    let minutes = startDateAndTime.getMinutes()
    return `${months[month]} ${day < 10 ? '0'+day : day}, ${year} at ${hour<10 ? '0'+hour:hour}:${minutes < 10 ? '0'+minutes : minutes} hrs`
}

export const formatActivityDay = (date) => {
    const createdDate = date.split("-");
    return `${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};


export const announcementsIsLoading = () => ({
    type: ANNOUNCEMENTS_IS_LOADING,
});

export const announcementsLoadingSuccess = (announcementsData) => ({
    type: ANNOUNCEMENTS_LOAD_SUCCESS,
    payload: announcementsData,
});

export const announcementsLoadingError = (errorMessage) => ({
    type: ANNOUNCEMENTS_LOAD_ERROR,
    payload: errorMessage,
});

export const statisticsIsLoading = () => ({
    type: STATISTICS_IS_LOADING,
});

export const statisticsLoadingSuccess = (statisticsData) => ({
    type: STATISTICS_LOAD_SUCCESS,
    payload: statisticsData,
});

export const statisticsLoadingError = (errorMessage) => ({
    type: STATISTICS_LOAD_ERROR,
    payload: errorMessage,
});

export const leadershipBoardIsLoading = () => ({
    type: LEADERSHIP_BOARD_IS_LOADING,
});

export const leadershipBoardLoadingSuccess = (leadershipBoardData) => ({
    type: LEADERSHIP_BOARD_LOAD_SUCCESS,
    payload: leadershipBoardData,
});

export const leadershipBoardLoadingError = (errorMessage) => ({
    type: LEADERSHIP_BOARD_LOAD_ERROR,
    payload: errorMessage,
});

export const reportsIsLoading = () => ({
    type: REPORTS_IS_LOADING,
});

export const reportsLoadingSuccess = (reportsData) => ({
    type: REPORTS_LOAD_SUCCESS,
    payload: reportsData,
});

export const reportsLoadingError = (errorMessage) => ({
    type: REPORTS_LOAD_ERROR,
    payload: errorMessage,
});

export const quizListIsLoading = () => ({
    type: QUIZ_LIST_IS_LOADING,
});

export const quizListLoadingSuccess = (quizListData) => ({
    type: QUIZ_LIST_LOAD_SUCCESS,
    payload: quizListData,
});

export const quizListLoadingError = (errorMessage) => ({
    type: QUIZ_LIST_LOAD_ERROR,
    payload: errorMessage,
});

export const resetQuizList = () => ({
    type: RESET_QUIZ_LIST
})

export const setTopicAndQuiz = (topic_id, quiz_id) => ({
    type: SET_TOPIC_AND_QUIZ,
    payload: { topic_id: topic_id, quiz_id: quiz_id }
})

export const resetTopicAndQuiz = () => ({
    type: RESET_TOPIC_AND_QUIZ
})

export const myActivityIsLoading = () => ({
    type: MY_ACTIVITY_IS_LOADING,
});

export const myActivityLoadingSuccess = (myActivityData) => ({
    type: MY_ACTIVITY_LOAD_SUCCESS,
    payload: myActivityData,
});

export const myActivityLoadingError = (errorMessage) => ({
    type: MY_ACTIVITY_LOAD_ERROR,
    payload: errorMessage,
});

export const myActivityReset = () => ({
    type: MY_ACTIVITY_RESET
})

export const liveCoursesIsLoading = () => ({
    type: LIVE_COURSES_IS_LOADING,
});

export const liveCourseLoadingSuccess = (liveCoursesData) => ({
    type: LIVE_COURSES_LOAD_SUCCESS,
    payload: liveCoursesData,
});

export const liveCourseLoadingError = (errorMessage) => ({
    type: LIVE_COURSES_LOAD_ERROR,
    payload: errorMessage,
});

export const topicStart = (id) => ({
    type: TOPIC_IS_STARTING,
    payload: id
})

export const topicStartSuccess = () => ({
    type: TOPIC_STARTED_SUCCESSFULLY
})

export const topicStartError = () => ({
    type: TOPIC_START_ERROR
})

export const topicStartReset = () => ({
    type: TOPIC_START_RESET
})

export const loadComments = () => ({
    type: COMMENTS_IS_LOADING
})

export const commentsLoadSuccess = (comments) => ({
    type: COMMENTS_LOAD_SUCCESS,
    payload: comments
})

export const commentsLoadError = (errorMessage) => ({
    type: COMMENTS_LOAD_ERROR,
    payload: errorMessage
})

export const resetComments = () => ({
    type: COMMENTS_RESET
})

export const searchAutocompleteList = (list) => ({
    type: SEARCH_AUTOCOMPLETE_LIST_LOADING,
    payload: list
})

export const searchQuery = (query) => ({
    type: SEARCH_QUERY_LOADING,
    payload: query
})

export const searchFinal = (query) => ({
    type: SEARCH_FINAL_QUERY,
    payload: query
})

export const searchReset = () => ({
    type: SEARCH_COMPONENT_RESET
})

export const setAutocompleteVisibility = (value) => ({
    type: SET_AUTOCOMPLETE_VISIBILITY,
    payload: value
})

export const setAdvancedSearchParams = (params) => ({
    type: SET_ADVANCED_SEARCH,
    payload: params
})

export const resetAdvancedSearchParams = () => ({
    type: RESET_ADVANCED_SEARCH
})

export const changeFavouriteValue = (id) => ({
    type: CHANGE_FAVOURITE_VALUE,
    payload: id
})

export const startSettingFavourite = () => ({
    type: START_SETTING_FAVOURITE
})

export const endSettingFavourite = () => ({
    type: END_SETTING_FAVOURITE
})